import { ToastMessage } from './../../providers/toast-message';
import { MyFirebaseList } from './../../providers/my-firebase-list';
import { ModelMetier } from './../../providers/model-metier';
import { MyFirebase } from './../../providers/my-firebase';
import { ApiV1 } from './../../providers/api-v1';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, AlertController, LoadingController } from 'ionic-angular';




/**
 * Generated class for the AttachLicidPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-attach-licid',
  templateUrl: 'attach-licid.html',
})
export class AttachLicidPage {


  // The cloudId
  cloudId : any;
  // Index select
  cloudIndex : any;

  // List Cloud
  public clouds : MyFirebaseList;
  

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, 
              public loadingCtrl: LoadingController, public toastMessage : ToastMessage,
              public modelMetier : ModelMetier, public myFirebase : MyFirebase) {

      this.clouds = this.modelMetier.clouds;
    // this.modelMetier.loaded().then( ()=> {
    //   this.clouds = this.modelMetier.clouds;
    // });

    // cloudId ?
    this.cloudIndex = 0;
    this.cloudId = this.navParams.get('cloudId');
    if (this.cloudId) this.cloudIndex = this.clouds.getPosEleId(this.cloudId);
  }


  ionViewDidLoad() {
    
    console.log('ionViewDidLoad AttachLicidPage');
  }



  uploadFile(fileList: FileList) {
    console.log('uploadFile: ' + fileList.length + ' ' + fileList.item[0]);
  }


  // Raw input lic ids
  private licIds:string;

  // Split, filter lic id Array
  private tabLicId : string[];

  private info = '';
  // Tableau de variables ? Name:Value ?
  // Object Variables { name:value...}





  // Confirmation Alert
  // return Promise true if Ok, false if cancel
  confirmation():Promise<any> {

    return new Promise((resolve, reject) => {

//@TODO si tres long ? btn inacessible...
      let msg = 'Are sur you want to attach this licId:<ul>';
      this.tabLicId.forEach(element => {
        msg = msg + '<li>"' + element + '"</li>';
      });
      msg = msg + '</ul>To  "' + this.clouds.getEleId(this.cloudId).name + '" ?'
          

      let alert = this.alertCtrl.create({
        title: 'Confirm action',
        subTitle: msg,
        buttons: [ 
          { text: 'Cancel', role: 'cancel', handler: () => { resolve(false); }  },
          { text: 'Ok', handler: () => { resolve(true); } }
        ]
      });
      
      alert.present();

    });
  
  }






  // Attach the licId to the cloud
  attachLicId(licId):Promise<any> {

    return this.modelMetier.attachLicIdToCloud(licId, this.info, this.cloudId);
  }


  attach() {

    if (!this.licIds) return;

    this.cloudId = this.clouds.elesFilterKeyValue[this.cloudIndex].key;


    // Get list licId
    this.tabLicId = this.modelMetier.getLicIds(this.licIds);

    // Message confirmation Ok, Cancel
    this.confirmation().then( (x) => {
            
      // Si Cancel, return
      // console.log('confirmation return ' + x);
      if (!x) return;



      let loader = this.loadingCtrl.create({
        content: "Please wait...",
      });
      loader.present();


      // Pour chaque licId tabLicId
      let promises = this.tabLicId.map( (licId)=> { 
        return this.attachLicId(licId);
      });

      
      return Promise.all(promises).then( ()=> { 

        loader.dismiss();
        this.toastMessage.success('Attach Ok');

      }).catch((err)=>{

        loader.dismiss();
        this.toastMessage.error(err);

      });

    })


    // Process attachement licId au cloud
    // Get all result, and wait
    // Quand tous les result, display toast Ok  ou Erreur, avec validation

  }


/*

  TODO

    cloud ion-select, ion-option  valeur par default Not connected

    Alert Ok, cancel si tres grand, ??? scroll list ?

    Btn file upload, faire chargement file




    get cloud list, in order array  MyFirebase, load list ordered

    display cloud list with in first 'Not connected'
      https://forum.ionicframework.com/t/ion-select-with-dynamic-options/43720/11

    open file, and load
      http://pjsdev.blogspot.fr/2016/05/ionic-2-beta-6-angular-2-styled-upload.html

    ask Ok, cancel

    extract, filtre licId
    loop 
      set licIdTag value, collecte result
    
    at end message

*/

}



// WEBPACK FOOTER //
// ./src/pages/attach-licid/attach-licid.ts